import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { containerStyles, hintStyles, reasonsListStyles } from './DisabledReasonTooltip.styles';
import { DisabledReasonTooltipTestIds } from './DisabledReasonTooltip.testIds';

const DisabledReasonTooltip = ({ title, reasons = [], hint = null }) => (
  <Box data-testid={DisabledReasonTooltipTestIds.CONTAINER} sx={containerStyles}>
    <Typography data-testid={DisabledReasonTooltipTestIds.TITLE} variant="medium12">
      {title}
    </Typography>
    {!!reasons.length && (
      <Box component="ul" sx={reasonsListStyles}>
        {reasons.map(({ id, text }) => (
          <Typography
            component="li"
            data-testid={DisabledReasonTooltipTestIds.REASON}
            key={id}
            variant="regular12"
          >
            {text}
          </Typography>
        ))}
      </Box>
    )}
    {!!hint && (
      <Typography
        data-testid={DisabledReasonTooltipTestIds.HINT}
        sx={hintStyles}
        variant="regular12"
      >
        {hint}
      </Typography>
    )}
  </Box>
);

DisabledReasonTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  hint: PropTypes.string,
  reasons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
};

export default memo(DisabledReasonTooltip);
